import React, { useMemo, useState } from 'react';
import { Layout, Tabs } from 'tea-component';
import { connect, getLocale, useIntl, useLocation } from 'umi';
import ContentBody from '@/pages/opinion/components/ContentBody';
import StreamingOverview from './pages/StreamingOverview';
import TextBubbles from '@home/components/TextBubbles';
import hatchet from '@/pages/opinion/assets/svg/hatchet.svg';
import { communitySteamingCommonTitleText } from '@op/components/BubbleCommon';
import DashboardReport from '@op/components/DashboardReport';
import '@op/assets/scss/pages/community/index.scss';
import '@op/assets/scss/pages/community/streaming.scss';
import { useFrontWebConfig } from '@op/hooks/useFrontWebConfig';
import { StreamingTabType } from '@op/hooks/useFrontWebConfig/types';

const { Content } = Layout;

function CommunityStreaming({ gameInfo, wholeGameInfo }: any) {
  const { formatMessage } = useIntl();

  const pageUrlInfo = useLocation();
  const pageUrlObj = pageUrlInfo?.query || {};
  const [activeId, setActiveId] = useState(pageUrlObj.tab || 'overview');
  const isEn = getLocale() === 'en-US';
  const tabsConfig: StreamingTabType = useFrontWebConfig({
    keys: 'streaming_tab',
  });

  const tabs = useMemo(() => {
    const list = tabsConfig?.filter(
      ({ hostname }) =>
        !hostname ||
        hostname.length === 0 ||
        hostname.includes(location.hostname),
    );

    if (!list?.length) return [];

    const defaultTab: { id: string; label: any; report?: string } = {
      id: 'overview',
      label: (
        <div className="dbo-channellabel">
          <img src={hatchet} width={16} height={16} alt="icon" />
          <TextBubbles
            rowNum={1}
            className="dbo-channellabel-text"
            text={formatMessage({ id: 'Streaming' })}
          />
        </div>
      ),
    };

    const dynamicTabs = list.map(({ id, label_en, label_cn, report }) => {
      return {
        id,
        label: (
          <div className="dbo-channellabel">
            <TextBubbles
              rowNum={1}
              className="dbo-channellabel-text"
              text={isEn ? label_en : label_cn}
            />
          </div>
        ),
        report,
      };
    });

    return [defaultTab, ...dynamicTabs];
  }, [formatMessage, isEn, tabsConfig]);

  const renderElement = useMemo(() => {
    if (!tabs?.length) {
      return (
        <StreamingOverview gameInfo={gameInfo} wholeGameInfo={wholeGameInfo} />
      );
    }

    const selectedTab = tabs.find((tab) => tab?.id === activeId);
    if (selectedTab?.report) {
      return (
        <DashboardReport
          id={selectedTab?.report}
          pageId={"20110"}
          className="dbo-streaming-report"
          pageName={'CommunityStreaming'}
        />
      );
    }

    return (
      <StreamingOverview gameInfo={gameInfo} wholeGameInfo={wholeGameInfo} />
    );
  }, [tabs, activeId, gameInfo, wholeGameInfo]);

  return (
    <Content className="dbo-streaming">
      <Content.Header
        className={tabs?.length > 0 ? 'contentHead-normal' : ''}
        title={formatMessage({ id: 'Streaming' })}
      >
        {tabs?.length > 0 && (
          <div className="header-tab">
            <Tabs
              ceiling
              tabs={tabs}
              animated={false}
              activeId={activeId}
              onActive={(tab) => {
                setActiveId(tab.id);
              }}
            />
          </div>
        )}
      </Content.Header>
      <ContentBody
        horseRaceLampTips={
          activeId === 'overview' ? communitySteamingCommonTitleText : undefined
        }
      >
        {renderElement}
      </ContentBody>
    </Content>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(CommunityStreaming);
